import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Radio } from 'antd';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { GeneralApi, ValuationApi } from '../../apis';
import { Dictionaries } from '../../interfaces';
import { formatCurrency } from '../../utils';
import { CarImagesUpload } from './car-images';

type Props = {
  action: {
    loading: boolean;
    payload: any;
  };
  setPercent: React.Dispatch<React.SetStateAction<number>>;
  setAction: any;
  setImage: (images: string[]) => void;
};

const ValuationResponseTable = ({ action, setPercent, setAction, setImage }: Props) => {
  const [general, setGeneral] = useState<Dictionaries>();
  const loadData = useCallback(async () => {
    const res = await GeneralApi.init();
    setGeneral(res);
  }, []);

  const [payload] = useState(action.payload);

  React.useEffect(() => {
    loadData();
  }, [loadData]);

  if (!payload) return <></>;

  return (
    <Wrap>
      <h3>Тайлангийн ерөнхий мэдээлэл</h3>
      <div className="grid-2">
        <table className="kv">
          <tbody>
            <tr>
              <td className="label">Зээл хүсэгчийн овог, нэр</td>
              <td className="value">{payload?.customer?.fullName}</td>
            </tr>
            <tr>
              <td className="label">Регистрийн дугаар</td>
              <td className="value">{payload?.customer?.registerNo}</td>
            </tr>
          </tbody>
        </table>

        <table className="kv">
          <tbody>
            <tr>
              <td className="label">Үнэлсэн ажилтны нэр</td>
              <td className="value">
                {' '}
                {payload?.valuationUser?.lastName} {payload?.valuationUser?.firstName}
              </td>
            </tr>
            <tr>
              <td className="label">Тайлангийн огноо</td>
              <td className="value">{dayjs(payload?.createdAt).format('YYYY-MM-DD')}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>Үнэлсэн автомашины мэдээлэл</h3>
      <table className="single-col">
        <tbody>
          <tr style={{ padding: 0 }}>
            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Марк</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {payload?.vehicle?.carBrand?.name}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] bg-[#FAFAFA] label">Загвар</div>
                <div className="flex flex-1 p-[12px]  bg-[#FFFFFF] value">
                  {payload?.vehicle?.carModel?.name}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Улсын дугаар</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {payload?.vehicle?.plateNumber}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Арлын дугаар</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {payload?.vehicle?.vin}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Үйлдвэрлэсэн он</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {payload?.vehicle?.manufacturedYear}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">
                  Монгол Улсад орж ирсэн он
                </div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {payload?.vehicle?.importedYear}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Зориулалт</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {payload?.vehicle?.type}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Явсан км</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {payload?.vehicle?.odo}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Хөдөлгүүрийн төрөл</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {
                    general?.engineTypes?.find((item) => item.code === payload?.vehicle?.engineType)
                      ?.name
                  }
                </div>
              </div>
            </td>
            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Хөтлөгч</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {
                    general?.drivetrain?.find((item) => item.code === payload?.vehicle?.drivetrain)
                      ?.name
                  }
                </div>
              </div>
            </td>
            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Хөдөлгүүрийн багтаамж</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {payload?.vehicle?.engineCapacity}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Хурдны хайрцаг</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {
                    (general?.transmissionTypes || [])?.find(
                      (item) => item.code === payload?.vehicle?.transmission
                    )?.name
                  }
                </div>
              </div>
            </td>
            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Хүрдний байрлал</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {
                    general?.steeringTypes?.find((item) => item.code === payload?.vehicle?.steering)
                      ?.name
                  }
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Тоноглол</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {payload?.vehicle?.option?.name}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Гадна өнгө</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {
                    general?.exteriorColors?.find(
                      (item) => item.code === payload?.vehicle?.exteriorColor
                    )?.name
                  }
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Салоны өнгө</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  {
                    general?.interiorColors?.find(
                      (item) => item.code === payload?.vehicle?.interiorColor
                    )?.name
                  }
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="h-[15px]" />

      <h3>Зураг</h3>
      <CarImagesUpload onChange={(e) => setImage(e)} />
      <div className="h-[15px]" />
      <h3>Үнэлгээ</h3>

      <table className="single-col">
        <tbody>
          <tr style={{ padding: 0 }}>
            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Үнэлгээний аргачлал</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">{payload.description}</div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">
                  Зохицуулагдсан үнэлгээ
                </div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF] font-bold">
                  {formatCurrency(payload.price)}
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">
                  Километрийн заалтаас хамаарсан зохицуулалт
                </div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF] font-bold">
                  <Radio.Group value="small" size="small">
                    <Radio.Button
                      onClick={async () => {
                        if (action.payload?.percentOdo <= -5) {
                          return null;
                        }

                        const newPercent = action.payload?.percentOdo - 1;

                        const res: any = await ValuationApi.calculate({
                          percentBranchHead: action.payload.percentBranchHead,
                          amount: payload.price,
                          percentOdo: newPercent,
                          hasVat: payload?.hasVat
                        });

                        setAction({
                          ...action,
                          payload: {
                            ...action.payload,
                            priceFinal: res,
                            percentOdo: newPercent,
                          },
                        });
                      }}
                    >
                      <MinusCircleOutlined />
                    </Radio.Button>

                    <Radio.Button value="default">{action.payload?.percentOdo}%</Radio.Button>

                    <Radio.Button
                      onClick={async () => {
                        if (action.payload?.percentOdo >= 5) {
                          return null;
                        }

                        const newPercent = action.payload.percentOdo + 1;

                        const res: any = await ValuationApi.calculate({
                          percentBranchHead: action.payload.percentBranchHead,
                          amount: payload.price,
                          percentOdo: newPercent,
                          hasVat: payload?.hasVat
                        });

                        setAction({
                          ...action,
                          payload: {
                            ...action.payload,
                            priceFinal: res,
                            percentOdo: newPercent,
                          },
                        });
                      }}
                    >
                      <PlusCircleOutlined />
                    </Radio.Button>
                  </Radio.Group>
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">
                  Салбарын удирдлагын зохицуулалт
                </div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF]">
                  <div className="printRadio">
                    <Radio.Group value="small" size="small">
                      <Radio.Button
                        onClick={async () => {
                          if (action.payload?.percentBranchHead <= -10) {
                            return null;
                          }

                          const newPercent = action.payload?.percentBranchHead - 1;

                          const res: any = await ValuationApi.calculate({
                            percentBranchHead: newPercent,
                            amount: payload.price,
                            percentOdo: action.payload?.percentOdo,
                            hasVat: payload?.hasVat
                          });

                          setAction({
                            ...action,
                            payload: {
                              ...action.payload,
                              priceFinal: res,
                              percentBranchHead: newPercent,
                            },
                          });
                        }}
                      >
                        <MinusCircleOutlined />
                      </Radio.Button>

                      <Radio.Button value="default">
                        {action.payload?.percentBranchHead}%
                      </Radio.Button>

                      <Radio.Button
                        onClick={async () => {
                          if (action.payload?.percentBranchHead >= 20) {
                            return null;
                          }

                          const newPercent = action.payload.percentBranchHead + 1;
                          const res: any = await ValuationApi.calculate({
                            percentBranchHead: newPercent,
                            amount: payload.price,
                            percentOdo: action.payload?.percentOdo,
                            hasVat: payload?.hasVat
                          });

                          setAction({
                            ...action,
                            payload: {
                              ...action.payload,
                              priceFinal: res,
                              percentBranchHead: newPercent,
                            },
                          });
                        }}
                      >
                        <PlusCircleOutlined />
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                </div>
              </div>
            </td>

            <td>
              <div className="flex flex-row border  border-[#E5E7EB] border-r-0 border-l border-b-0">
                <div className="flex flex-1 p-[12px] label bg-[#FAFAFA]">Эцэслэсэн үнэлгээ</div>
                <div className="flex flex-1 p-[12px] value bg-[#FFFFFF] font-bold">
                  {formatCurrency(action.payload?.priceFinal)}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </Wrap>
  );
};

const Wrap = styled.div`
  --bg: #fff;
  --text: #111827;
  --muted: #6b7280;
  --border: #e5e7eb;
  --accent: #3b82f6;

  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, 'Noto Sans',
    'Helvetica Neue', sans-serif;
  color: var(--text);

  max-width: 590px;

  /* Дээд 2 хүснэгтийг зэрэгцүүлэх */
  .grid-2 {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    margin-bottom: 18px;
  }

  /* Key–value 2 мөртэй цэвэр харагдах table */
  table.kv {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
  }
  table.kv tbody {
    display: block;
  }
  table.kv tr {
    display: grid;
    grid-template-columns: 1fr auto; /* зүүн label | баруун value */
    gap: 8px;
    padding: 12px 14px;
    border-bottom: 1px solid var(--border);
  }
  table.kv tr:last-child {
    border-bottom: 0;
  }
  table.kv td {
    border: 0;
    padding: 0;
  }
  table.kv td.label {
    font-size: 12px;
    font-weight: 600;
    color: var(--muted);
  }
  table.kv td.value {
    font-size: 12px;
    font-weight: 600;
    text-align: right;
  }

  h3 {
    font-size: 13px;
    font-weight: 800;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    position: relative;
    padding-left: 10px;
    margin-bottom: 15px;
  }
  h3::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 14px;
    background: var(--accent);
    border-radius: 2px;
  }

  /* Нэг багана – label дээр, value доор */
  table.single-col {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid var(--border);
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
  }
  table.single-col tr {
    display: block;
    padding: 12px 14px;
    border-bottom: 1px solid var(--border);
  }
  table.single-col tr:nth-child(even) {
    background: #fafafa;
  }
  table.single-col tr:last-child {
    border-bottom: 0;
  }
  table.single-col td {
    display: block;
    border: 0;
    padding: 0;
  }
  .label {
    font-size: 12px;
    font-weight: 700;
    color: var(--muted);
    margin-bottom: 4px;
  }
  .value {
    font-size: 12px;
    color: var(--text);
  }

  /* Responsive + print */
  @media (max-width: 768px), print {
    .grid-2 {
      grid-template-columns: 1fr;
      gap: 12px;
    }
    table.kv tr {
      grid-template-columns: 1fr;
    }
    table.kv td.value {
      text-align: left;
      font-weight: 500;
    }
    h3::before {
      background: #000;
    } /* print-friendly */
  }
`;

export { ValuationResponseTable };
